import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { InstallationFeaturesStore, RichDevice } from '@store';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-device-time-warning',
  templateUrl: './device-time-warning.component.html',
  styleUrls: ['./device-time-warning.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DeviceTimeWarningComponent implements OnInit {
  @Input() device: RichDevice;

  offSetDeviceTime$: Observable<Date>;

  constructor(public installationFeaturesStore: InstallationFeaturesStore) {}
  ngOnInit(): void {
    this.offSetDeviceTime$ = this.installationFeaturesStore.getOffsetDeviceTime();
  }
}
